module.exports = __webpack_public_path__ + "4ab77372c0d5008096313d7f3b97d2db.woff";


//////////////////
// WEBPACK FOOTER
// ./libs/font-awesome/webfonts/fa-regular-400.woff
// module id = 351
// module chunks = 0